import { E_TipoParavento, E_TipoOmbrellone, E_GenereOmbrellone, E_MisureOmbrelloni } from "./enumerations";

import { OmbrelloneBraccioAvantage } from "../Ombrelloni/OmbrelloneBraccioAvantage";
import { OmbrelloneBraccioDeLuxe } from "../Ombrelloni/OmbrelloneBraccioDeLuxe";
import { OmbrelloneBraccioRoma} from "../Ombrelloni/OmbrelloneBraccioRoma";
import { OmbrelloneBraccioDiffusion } from "../Ombrelloni/OmbrelloneBraccioDiffusion";
import { OmbrelloneBraccioPratiqueClassic } from "../Ombrelloni/OmbrelloneBraccioPratiqueClassic";
import { OmbrelloneBraccioPratiqueContract } from "../Ombrelloni/OmbrelloneBraccioPratiqueContract";
import { OmbrelloneCentraleFacility } from "../Ombrelloni/OmbrelloneCentraleFacility";
import { OmbrelloneCentralePlatinoBasic } from "../Ombrelloni/OmbrelloneCentralePlatinoBasic";
import { OmbrelloneCentralePlatinoMedium } from "../Ombrelloni/OmbrelloneCentralePlatinoMedium";
import { OmbrelloneSbalzoMezzombra } from "../Ombrelloni/OmbrelloneSbalzoMezzombra";

import { OmbrelloneBraccioAvantageMantovana } from "../Ombrelloni/OmbrelloneBraccioAvantage";
import { OmbrelloneBraccioDiffusionMantovana } from "../Ombrelloni/OmbrelloneBraccioDiffusion";
import { OmbrelloneBraccioPratiqueClassicMantovana } from "../Ombrelloni/OmbrelloneBraccioPratiqueClassic";
import { OmbrelloneBraccioPratiqueContractMantovana } from "../Ombrelloni/OmbrelloneBraccioPratiqueContract";
import { OmbrelloneBraccioRomaMantovana } from "../Ombrelloni/OmbrelloneBraccioRoma";
import { OmbrelloneCentraleFacilityMantovana } from "../Ombrelloni/OmbrelloneCentraleFacility";
import { OmbrelloneCentralePlatinoBasicMantovana } from "../Ombrelloni/OmbrelloneCentralePlatinoBasic";
import { OmbrelloneCentralePlatinoMediumMantovana } from "../Ombrelloni/OmbrelloneCentralePlatinoMedium";
import { OmbrelloneSbalzoMezzombraMantovana } from "../Ombrelloni/OmbrelloneSbalzoMezzombra";
import { OmbrelloneBraccioDeLuxeMantovana } from "../Ombrelloni/OmbrelloneBraccioDeLuxe";

import { ParaventoRubino } from "../Paraventi/ParaventoRubino";
import { ParaventoSlim } from "../Paraventi/ParaventoSlim";
import { ParaventoSmeraldo } from "../Paraventi/ParaventoSmeraldo";
import { ParaventoTopazio } from "../Paraventi/ParaventoTopazio";
import { ParaventoUnico100 } from "../Paraventi/ParaventoUnico100";
import { ParaventoUnico150 } from "../Paraventi/ParaventoUnico150";
import { ParaventoScreenUp100 } from "../Paraventi/ParaventoScreenUp100";

import { BasamentoAvantage } from "../BasementiOmbrelloni/BasamentoAvantage";
import { BasamentoDiffusion } from "../BasementiOmbrelloni/BasamentoDiffusion";
import { BasamentoFacility } from "../BasementiOmbrelloni/BasamentoFacility";
import { BasamentoMezzombra } from "../BasementiOmbrelloni/BasamentoMezzombra";
import { BasamentoPlatino } from "../BasementiOmbrelloni/BasamentoPlatinoBasic";
import { BasamentoPratique } from "../BasementiOmbrelloni/BasamentoPratique";
import { BasamentoRoma } from "../BasementiOmbrelloni/BasamentoRoma";
import { BasamentoDeLuxe } from "../BasementiOmbrelloni/BasamentoDeLuxe";

// Lista paraventi
const paraventiConfiguration = [
  {
    meshName: E_TipoParavento.Slim_100,    
    meshScale: [0.35, 0.37, 0.35],
    meshMaxScale: 1,
    percOffset: 0.399,
    altezza: 0.95,
    mesh: <ParaventoSlim />
  },
  {
    meshName: E_TipoParavento.Unico_100,
    meshScale: [0.35, 0.38, 0.35],
    meshMaxScale: 1,
    percOffset: 0.399,
    altezza: 0.97,
    mesh: <ParaventoUnico100 />
  },  
  {
    meshName: E_TipoParavento.Unico_150,
    meshScale: [0.35, 0.55, 0.35],
    meshMaxScale: 1,
    percOffset: 0.266,
    altezza: 1.4,
    mesh: <ParaventoUnico150 />
  },
  {
    meshName: E_TipoParavento.Smeraldo,
    meshScale: [0.35, 0.37, 0.35],
    meshMaxScale: 1,
    percOffset: 0.266,
    altezza: 1.4,
    mesh: <ParaventoSmeraldo />
  },
  {
    meshName: E_TipoParavento.Rubino,    
    meshScale: [2.5, 3.7, 2.5],
    meshMaxScale: 1,
    percOffset: 2.7,
    altezza: 1.45,
    mesh: <ParaventoRubino />
  },
  {
    meshName: E_TipoParavento.Topazio,
    meshScale: [0.35, 0.38, 0.35],
    meshMaxScale: 1,
    percOffset: 0.265,
    altezza: 1.45,
    mesh: <ParaventoTopazio />
  },
  {
    meshName: E_TipoParavento.Screen_Up_100,
    meshScale: [2.5, 2.9, 2.5],
    meshMaxScale: 1,
    percOffset: 4.06,
    altezza: 1.6,
    mesh: <ParaventoScreenUp100 />
  }
];

// Lista ombrelloni
const ombrelloniConfiguration = [
  {    
    meshSpecificName: E_TipoOmbrellone.Avantage, 
    meshGenere: E_GenereOmbrellone.Braccio,  
    meshScale: [1.35, 4, 1.02],  
    meshDimensions: [E_MisureOmbrelloni.Scegli, E_MisureOmbrelloni._2X3, E_MisureOmbrelloni._3X3, E_MisureOmbrelloni._3mX3m, E_MisureOmbrelloni._3X4, E_MisureOmbrelloni._4X4],
    mesh: <OmbrelloneBraccioAvantage/>,
    meshMantovana: <OmbrelloneBraccioAvantageMantovana/>,
    meshBase: <BasamentoAvantage />,
    offSetPosizioneOmbrellone: [0, 0.025, -0.3],
    grondaiaY: 2.4,
    grondaiaYMantovana: 2.3,
    grondaiaOffsetLato: -0.3,
    altezzaLateraleCristal: 2.15, 
  },
  {    
    meshSpecificName: E_TipoOmbrellone.DeLuxe, 
    meshGenere: E_GenereOmbrellone.Braccio,  
    meshScale: [1.95, 4, 1.3],  
    meshDimensions: [E_MisureOmbrelloni.Scegli, E_MisureOmbrelloni._2X3, E_MisureOmbrelloni._3X3, E_MisureOmbrelloni._3mX3m, E_MisureOmbrelloni._3X4, E_MisureOmbrelloni._4X4, E_MisureOmbrelloni._3X5, E_MisureOmbrelloni._4X5],
    mesh: <OmbrelloneBraccioDeLuxe/>,
    meshMantovana: <OmbrelloneBraccioDeLuxeMantovana/>,
    meshBase: <BasamentoDeLuxe/>,
    offSetPosizioneOmbrellone: [0, 0, 0.28],
    grondaiaY: 2.83,
    grondaiaYMantovana: 2.83,
    grondaiaOffsetLato: 0.32,
    altezzaLateraleCristal: 2.54,   
  },
  {    
    meshSpecificName: E_TipoOmbrellone.Diffusion, 
    meshGenere: E_GenereOmbrellone.Braccio,  
    meshScale: [1.97, 4, 1.305],  
    meshDimensions: [E_MisureOmbrelloni.Scegli, E_MisureOmbrelloni._2X2, E_MisureOmbrelloni._2X2m, E_MisureOmbrelloni._2X3, E_MisureOmbrelloni._2X3m, E_MisureOmbrelloni._3X3, E_MisureOmbrelloni._3X4],
    mesh: <OmbrelloneBraccioDiffusion/>,
    meshMantovana: <OmbrelloneBraccioDiffusionMantovana/>,
    meshBase: <BasamentoDiffusion/>,
    offSetPosizioneOmbrellone: [0, 0, 0.14],
    grondaiaY: 2.83,
    grondaiaYMantovana: 2.78,
    grondaiaOffsetLato: 0.165,
    altezzaLateraleCristal: 2.5,   
  }, 
  {    
    meshSpecificName: E_TipoOmbrellone.PratiqueClassic, 
    meshGenere: E_GenereOmbrellone.Braccio,  
    meshScale: [2, 4, 1.305],  
    meshDimensions: [E_MisureOmbrelloni.Scegli, E_MisureOmbrelloni._2X3, E_MisureOmbrelloni._3X3, E_MisureOmbrelloni._3mX3m, E_MisureOmbrelloni._3X4, E_MisureOmbrelloni._4X4],
    mesh: <OmbrelloneBraccioPratiqueClassic/>,
    meshMantovana: <OmbrelloneBraccioPratiqueClassicMantovana/>,
    meshBase: <BasamentoPratique/>,
    offSetPosizioneOmbrellone: [0, 0, 0.3],
    grondaiaY: 2.59,
    grondaiaYMantovana: 2.57,
    grondaiaOffsetLato: 0.3,
    altezzaLateraleCristal: 2.33,   
  },
  {    
    meshSpecificName: E_TipoOmbrellone.PratiqueContract, 
    meshGenere: E_GenereOmbrellone.Braccio,  
    meshScale: [2, 4, 1.305],  
    meshDimensions: [E_MisureOmbrelloni.Scegli, E_MisureOmbrelloni._2X3, E_MisureOmbrelloni._3X3, E_MisureOmbrelloni._3X4],
    mesh: <OmbrelloneBraccioPratiqueContract/>,
    meshMantovana: <OmbrelloneBraccioPratiqueContractMantovana/>,
    meshBase: <BasamentoPratique/>,
    offSetPosizioneOmbrellone: [0, 0, 0.3],
    grondaiaY: 2.59,
    grondaiaYMantovana: 2.51,
    grondaiaOffsetLato: 0.31,
    altezzaLateraleCristal: 2.3,   
  },
  {    
    meshSpecificName: E_TipoOmbrellone.Roma, 
    meshGenere: E_GenereOmbrellone.Braccio,  
    meshScale: [1.39, 4, 1.03],  
    meshDimensions: [E_MisureOmbrelloni.Scegli, E_MisureOmbrelloni._2X3, E_MisureOmbrelloni._3X3, E_MisureOmbrelloni._3X3, E_MisureOmbrelloni._2X4, E_MisureOmbrelloni._3X4],
    mesh: <OmbrelloneBraccioRoma/>,
    meshMantovana: <OmbrelloneBraccioRomaMantovana/>,
    meshBase: <BasamentoRoma/>,
    offSetPosizioneOmbrellone: [0, 0.025, -0.45],
    grondaiaY: 2.54,
    grondaiaYMantovana: 2.39,
    grondaiaOffsetLato: -0.44,
    altezzaLateraleCristal: 2.28,   
  },
  {    
    meshSpecificName: E_TipoOmbrellone.Facility, 
    meshGenere: E_GenereOmbrellone.Centrale,  
    meshScale: [1.32, 4, 1.96],  
    meshDimensions: [E_MisureOmbrelloni.Scegli, E_MisureOmbrelloni._3X3, E_MisureOmbrelloni._3X4, E_MisureOmbrelloni._3mX3m, E_MisureOmbrelloni._4X4, E_MisureOmbrelloni._3X5],
    mesh: <OmbrelloneCentraleFacility/>,
    meshMantovana: <OmbrelloneCentraleFacilityMantovana/>,
    meshBase: <BasamentoFacility/>,
    offSetPosizioneOmbrellone: [0, 0.025, 0],
    grondaiaY: 2.61,
    grondaiaYMantovana: 2.57,
    grondaiaOffsetLato: -0.1,
    altezzaLateraleCristal: 2.15,   
  },
  {    
    meshSpecificName: E_TipoOmbrellone.PlatinoBasic, 
    meshGenere: E_GenereOmbrellone.Centrale,  
    meshScale: [1.05, 4, 0.993],  
    meshDimensions: [E_MisureOmbrelloni.Scegli, E_MisureOmbrelloni._4X4, E_MisureOmbrelloni._4mX4m, E_MisureOmbrelloni._3X5, E_MisureOmbrelloni._4X5, E_MisureOmbrelloni._5X5],
    mesh: <OmbrelloneCentralePlatinoBasic/>,
    meshMantovana: <OmbrelloneCentralePlatinoBasicMantovana/>,
    meshBase: <BasamentoPlatino/>,
    offSetPosizioneOmbrellone: [0, 0.025, 0],
    grondaiaY: 2.96,
    grondaiaYMantovana: 2.75,
    grondaiaOffsetLato: -0.1,
    altezzaLateraleCristal: 2.45,   
  },
  {    
    meshSpecificName: E_TipoOmbrellone.PlatinoMedium, 
    meshGenere: E_GenereOmbrellone.Centrale,  
    meshScale: [0.665, 4, 0.665],  
    meshDimensions: [E_MisureOmbrelloni.Scegli, E_MisureOmbrelloni._3X5, E_MisureOmbrelloni._3mX5, E_MisureOmbrelloni._4X5, E_MisureOmbrelloni._5X5, E_MisureOmbrelloni._4mX5m, E_MisureOmbrelloni._5mX5m, E_MisureOmbrelloni._3X6, E_MisureOmbrelloni._4X6, E_MisureOmbrelloni._5X6, E_MisureOmbrelloni._6X6, E_MisureOmbrelloni._3X7, E_MisureOmbrelloni._5X7],
    mesh: <OmbrelloneCentralePlatinoMedium/>,
    meshMantovana: <OmbrelloneCentralePlatinoMediumMantovana/>,
    meshBase: <BasamentoPlatino/>,
    offSetPosizioneOmbrellone: [0, 0.025, 0],
    grondaiaY: 3.27,
    grondaiaYMantovana: 3.1,
    grondaiaOffsetLato: -0.1,
    altezzaLateraleCristal: 2.62,   
  },
  {    
    meshSpecificName: E_TipoOmbrellone.Mezzombra, 
    meshGenere: E_GenereOmbrellone.Sbalzo,  
    meshScale: [4.1, 4, 1.3], 
    meshDimensions: [E_MisureOmbrelloni.Scegli, E_MisureOmbrelloni._1mX3, E_MisureOmbrelloni._1mX2, E_MisureOmbrelloni._2X2, E_MisureOmbrelloni._1X3, E_MisureOmbrelloni._2X3, E_MisureOmbrelloni._1mX4, E_MisureOmbrelloni._2X4],
    mesh: <OmbrelloneSbalzoMezzombra/>,
    meshMantovana: <OmbrelloneSbalzoMezzombraMantovana/>,
    meshBase: <BasamentoMezzombra/>,
    offSetPosizioneOmbrellone: [0, 0.025, -0.05],
    grondaiaY: 2.62,
    grondaiaYMantovana: 2.52,
    grondaiaOffsetLato: 0.1,
    altezzaLateraleCristal: 2.38,   
  },
];

export { paraventiConfiguration, ombrelloniConfiguration };
